<template>
    <div  class="mx-auto" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px; text-align:justify;">


     <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
        
        :is-full-page="fullPage"></loading>

<b-modal ref="my-modal" class="text-center" hide-footer title="Are you sure you want to cancel ?">
      <div class="d-block text-center">
        <h3 style="font-size: 19px;"></h3>
      </div>
      
      <v-row no-gutters style="text-align:center;">

            <v-col cols="6"  sm="4" >
               <b-button size="sm" class="mt-2" style="margin-right:5px;" variant="outline-danger" block @click="hideModal">No</b-button>
            </v-col>
            
             <v-col cols="6"  sm="4" >
                <b-button size="sm" class="mt-2" style="margin-left:5px;" variant="outline-success" block @click="deleteitem">Yes</b-button>
            </v-col>
      </v-row>
     
     
    </b-modal>
  <v-expansion-panels class=""  v-if="orderlist">
      <v-expansion-panel v-for="(item,i) in orderlist" :key="i" >
                      <v-expansion-panel-header expand-icon="mdi-menu-down" style="text-align: left !important;">  
                        
                          <v-col cols="4" read>
             <v-flex xs12 ><b style="color: darkorange;    text-align: left;">#</b><b style="color: maroon;"> {{item.ReferNo}}</b></v-flex> <v-flex xs12><b style="color: darkorange;    text-align: left;"></b><b style="color: maroon;"> <span style="color:darkorange;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.NetAmount)}}</b></v-flex>
             </v-col>
             
            
               <v-col cols="8" read1 style="text-align: right;">
             <v-flex xs12><b style="color:darkorange; text-align:right;"></b><b style="color: maroon;">{{splitdate(item.OrderDate)}}</b> </v-flex> <v-flex xs12><b style="color: darkorange;    text-align: right;"></b><b style="color: maroon;">{{item.OrderStatus}}</b></v-flex>
             </v-col>
            
              </v-expansion-panel-header>
        <v-expansion-panel-content>

          <!-- grid started -->
   <v-container class="grey lighten-5">

      <v-row no-gutters style="text-align:left;">
            <v-col cols="6"  sm="4" hidden>
              Customer Id : <b><br>{{item.CustomerId}}</b>
            </v-col>
            <v-col cols="6"  sm="4" >
              Sub Total : <b><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.TotalAmount)}}</b>
            </v-col>
             <v-col cols="6"  sm="4" >
                Delivery Charge : <b><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.DeliveryCharge)}}</b>
               
            </v-col>
         
            <v-col cols="6"  sm="4" hidden >
             Order ID : <b class="" ><br>{{item.OrderId}}</b>
            </v-col>
             <v-col cols="6"  sm="4" >
               Discount : <b class="" ><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.Discount)}}</b>
            </v-col>
            <v-col cols="6"  sm="4" >
               Net Amount : <b><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.NetAmount)}}</b>
            </v-col>
          
          
            <v-col cols="6"  sm="4" >
              Order Date : <b><br>{{splitdate(item.OrderDate)}}</b>
            </v-col>
            <v-col cols="6"  sm="4" >
              Delivery Date : <b><br>{{splitdate(item.DeliveryDate)}}</b>
            </v-col>
             <v-col cols="6"  sm="4" >
                Order Status : 
            </v-col>
              <v-col cols="6"  sm="4" >
                <b class="" >{{item.OrderStatus}}</b>
            </v-col>
          </v-row>
           <div style="text-align:center; margin-bottom:1em;margin-top:1em;">
           <v-btn v-if="item.OrderStatus != 'Order Cancelled'" @click="confirmDel(i,item.OrderId)" style="background:#ffc10794;">
              Cancel Order 
             <v-icon style="">mdi-delete</v-icon>
           </v-btn>
           
            </div>
          <div style="background:#e9ecef; border-radius:10px;text-align:center;">
            Item Order Details
            </div>

    <v-row no-gutters>
      <v-col  v-for="(ord,i) in item.OrderDetailsList"  :key="i" cols="12"  sm="4" >
        <v-card class="pa-2 text-left" outlined tile >
        
        <!-- <v-avatar size="62">
      <img
        :src="ord.Barcode"
        :alt="ord.ItemName"
      >
    </v-avatar> -->

          <v-row no-gutters>
            <!-- <v-col cols="6"  sm="4" >
              Barcode : <b>{{ord.Barcode}}</b>
            </v-col> -->
             <v-col cols="12"  sm="12" :title="ord.ItemName">
               <b class="" >{{ord.ItemName}}</b>
            </v-col>
          </v-row>

           <v-row no-gutters>
            <v-col cols="7"  sm="4" hide style="text-align:left !important;">
              Barcode : <b>{{ord.Barcode}}</b>
            </v-col>
             <v-col cols="5"  sm="4" style="text-align:left !important;">
               Quantity : <b >{{ord.Quantity}}</b>
            </v-col>
          </v-row>

           <v-row no-gutters>
            <v-col cols="7"  sm="4" style="    text-align: left;">
              Amount : <b><span style="color:#000;font-size:15px;">{{currency}}&nbsp;</span>{{ formatPrice(ord.Amount)}}</b>
            </v-col>
             <v-col cols="5"  sm="4" :title="ord.ItemName">
              Rate : <b class="" ><span style="color:#000;font-size:15px;">{{currency}}&nbsp;</span>{{formatPrice(ord.Rate)}}</b>
            </v-col>
          </v-row>
        
           <v-row no-gutters>
           
            
          </v-row>
          <div style="height:2px; background: #9e9e9e8c;">
          </div>
         
        </v-card>
      </v-col>
     
    </v-row>
  </v-container>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- reg user -->



    <v-expansion-panels class="" v-if="orderlist1">
      <v-expansion-panel v-for="(item,i) in orderlist1" :key="i" >
                      <v-expansion-panel-header expand-icon="mdi-menu-down" style="text-align: left !important;">  
                        
                          <v-col cols="4" read>
             <v-flex xs12 ><b style="color: darkorange;    text-align: left;">#</b><b style="color: maroon;"> {{item.ReferNo}}</b></v-flex> <v-flex xs12><b style="color: darkorange;    text-align: left;"></b><b style="color: maroon;"> <span style="color:darkorange;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.NetAmount)}}</b></v-flex>
             </v-col>
             
            
               <v-col cols="8" read1 style="text-align: right;">
             <v-flex xs12><b style="color:darkorange; text-align:right;"></b><b style="color: maroon;">{{splitdate(item.OrderDate)}}</b> </v-flex> <v-flex xs12><b style="color: darkorange;    text-align: right;"></b><b style="color: maroon;">{{item.OrderStatus}}</b></v-flex>
             </v-col>
            
              </v-expansion-panel-header>
        <v-expansion-panel-content>

          <!-- grid started -->
   <v-container class="grey lighten-5">

      <v-row no-gutters style="text-align:left;">
            <v-col cols="6"  sm="4" hidden>
              Customer Id : <b><br>{{item.CustomerId}}</b>
            </v-col>
            <v-col cols="6"  sm="4" >
              Sub Total : <b><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.TotalAmount)}}</b>
            </v-col>
             <v-col cols="6"  sm="4" >
                Delivery Charge : <b><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.DeliveryCharge)}}</b>
               
            </v-col>
         
            <v-col cols="6"  sm="4" hidden >
             Order ID : <b class="" ><br>{{item.OrderId}}</b>
            </v-col>
             <v-col cols="6"  sm="4" >
               Discount : <b class="" ><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.Discount)}}</b>
            </v-col>
            <v-col cols="6"  sm="4" >
               Net Amount : <b><br><span style="color:#000;font-size:10px;">{{currency}}&nbsp;</span>{{formatPrice(item.NetAmount)}}</b>
            </v-col>
          
          
            <v-col cols="6"  sm="4" >
              Order Date : <b><br>{{splitdate(item.OrderDate)}}</b>
            </v-col>
            <v-col cols="6"  sm="4" >
              Delivery Date : <b><br>{{splitdate(item.DeliveryDate)}}</b>
            </v-col>
             <v-col cols="6"  sm="4" >
                Order Status : 
            </v-col>
              <v-col cols="6"  sm="4" >
                <b class="" >{{item.OrderStatus}}</b>
            </v-col>
          </v-row>
           <div style="text-align:center; margin-bottom:1em;margin-top:1em;">
           <v-btn v-if="item.OrderStatus != 'Order Cancelled'" @click="confirmDel(i,item.OrderId)" style="background:#ffc10794;">
              Cancel Order
             <v-icon style="">mdi-delete</v-icon>
           </v-btn>
           
            </div>
          <div style="background:#e9ecef; border-radius:10px;text-align:center;">
            Item Order Details
            </div>

    <v-row no-gutters>
      <v-col  v-for="(ord,i) in item.OrderDetailsList"  :key="i" cols="12"  sm="4" >
        <v-card class="pa-2 text-left" outlined tile >
        
        <!-- <v-avatar size="62">
      <img
        :src="ord.Barcode"
        :alt="ord.ItemName"
      >
    </v-avatar> -->

          <v-row no-gutters>
            <!-- <v-col cols="6"  sm="4" >
              Barcode : <b>{{ord.Barcode}}</b>
            </v-col> -->
             <v-col cols="12"  sm="12" :title="ord.ItemName">
               <b class="" >{{ord.ItemName}}</b>
            </v-col>
          </v-row>

           <v-row no-gutters>
            <v-col cols="7"  sm="4" hide style="text-align:left !important;">
              Barcode : <b>{{ord.Barcode}}</b>
            </v-col>
             <v-col cols="5"  sm="4" style="text-align:left !important;">
               Quantity : <b >{{ord.Quantity}}</b>
            </v-col>
          </v-row>

           <v-row no-gutters>
            <v-col cols="7"  sm="4" style="    text-align: left;">
              Amount : <b><span style="color:#000;font-size:15px;">{{currency}}&nbsp;</span>{{ formatPrice(ord.Amount)}}</b>
            </v-col>
             <v-col cols="5"  sm="4" :title="ord.ItemName">
              Rate : <b class="" ><span style="color:#000;font-size:15px;">{{currency}}&nbsp;</span>{{formatPrice(ord.Rate)}}</b>
            </v-col>
          </v-row>
        
           <v-row no-gutters>
           
            
          </v-row>
          <div style="height:2px; background: #9e9e9e8c;">
          </div>
         
        </v-card>
      </v-col>
     
    </v-row>
  </v-container>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div  v-if="emptyshow" class="mx-auto" style=""> 
<div style="    text-align: center;"><img :src="notfound">
</div>

  <div class="text-center text-danger" >Sorry you dont have any order history</div>
  <div class="text-center " style="margin-top:1rem">
   <v-btn   to="/" style="background:#009900; color:#fff; hight:100%">
      Continue Shopping
    </v-btn>
   </div>
 </div>
    </div>
</template>
<script>

import Vue from 'vue'
 import axios from 'axios';
import Loading from 'vue-loading-overlay';
    // Import stylesheet
 import Router from '../router';
 import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
            Loading
        },
    data: () => ({
      orderlist:[],
      orderlist1:[],
      delpos:'',
      reason:'',
      dump:'',
       isLoading: false,
      fullPage: true,
      orderId:'',
      totalamout:0,
      currency:'',
      subtotal:0,
       notfound:"https://img.icons8.com/clouds/2x/favorite-cart.png",
       snackbar: {
                show: false,
                message: null,
                color: null
            },
       userName:'',
       emptyshow:false,
       
    }),
    watch: {
    orderlist1: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
       for(this.i=0;this.i<this.orderlist1.length;this.i++)
           {

               this.orderDetailesList=this.orderlist1[this.i].OrderDetailsList;
           this.TotalAmount=0;
           console.log( this.TotalAmount)
           for(this.j=0;this.j<this.orderDetailesList.length;this.j++)
           {
             this.TotalAmount+=parseFloat(this.orderDetailesList[this.j].Amount);
           }
             console.log( this.TotalAmount)
          this.orderlist1[this.i].TotalAmount=this.TotalAmount;
          
          }
    },
     orderlist: function(newValue, oldValue) {
     console.log(newValue+" "+oldValue)
        for(this.i=0;this.i<this.orderlist.length;this.i++)
           {

               this.orderDetailesList=this.orderlist[this.i].OrderDetailsList;
           this.TotalAmount=0;
           for(this.j=0;this.j<this.orderDetailesList.length;this.j++)
           {
             this.TotalAmount+=parseFloat(this.orderDetailesList[this.j].Amount);
           }
          this.orderlist[this.i].TotalAmount=this.TotalAmount;
          
          }
       
    }
    },
    mounted(){
      this.userName=localStorage.getItem("logeduserId");
      this.currency = localStorage.getItem("currency");
           if (localStorage.getItem("islogedIn") !== null) {
                 this.getorderdata()
                 

               
            }else
            {
                this.orderlist =JSON.parse(localStorage.getItem("orderdetails"))
                this.emptyshow =false

             
            }
      
      this.decimalPlaces=localStorage.getItem("decimalPlaces");
        // this.$parent.$children[0].$parent.itemcountnumber = localStorage.getItem("cartcount");
       
           
            
              // this.deliveryCharge1=parseFloat(this.netAmount)+parseFloat(this.deliveryCharge);
              
       
    },
    methods:{
      getorderdata(){
            axios.get(this.$bURL+"registeredcustomer/GetOnlineOrders?Username="+this.userName)
              .then((response)  =>  {
                // console.log(response.data)
              
              if(response.data.length >0){
                     this.orderlist1 = response.data
                     
              }else{
                  this.emptyshow=true
                    // console.log("b"+response.data.length)
              }
                
             }, (error)  =>  {
                  console.log(error)
             })
      },
      //---------------------------------------------------------------
       formatPrice(value) {
        const val = (value/1).toFixed(  this.decimalPlaces);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
      splitdate(str){
        
 
  this.res = str.split("T");
  return this.res[0];

      },
      confirmDel(del,id)
      {
        // localStorage.setItem("delpos",del);
        // localStorage.setItem("orderId",orderId);
        this.orderId = id
        this.delpos = del
        this.$refs['my-modal'].show()
         
        
    
      },
       hideModal() {
        this.$refs['my-modal'].hide()
       },
       deleteitem()
       {
         
         if(this.reason)
         {
          this.dump = this.reason
         }else{
           this.dump = "Cancel"
         }
      
      this.isLoading = true;
      // this.loading = true;
      if (localStorage.getItem("islogedIn") !== null) {
      axios.patch(this.$bURL+"OnlineOrder/UpdateOrderStatusRemarks?OrderId="+this.orderId+"&OrderStatus=Order Cancelled&Remarks="+this.dump+"&IsAppendRemarks=False")
      .then((response)  =>  {
       this.hideModal()
     
          this.snackbar = {
                        message: 'Order Canceled Successfully',
                        color: 'success',
                        show: true
                    }
                    this.reason = ''
           this.getorderdata()
        //  localStorage.setItem("orderdetails",JSON.stringify(this.orderlist))
        setTimeout(() => {
                  this.isLoading = false
                   Router.push('/account');
         },1000)
      }, (error)  =>  {
          console.log(error)
      })
      }else{
        this.hideModal()
        this.orderlist[this.delpos].OrderStatus= "Order Cancelled"
        this.isLoading = false
        localStorage.setItem("orderdetails",JSON.stringify(this.orderlist))
        this.snackbar = {
                        message: 'Your are here',
                        color: 'success',
                        show: true
                    }
      }
      //-----------
       }
    }
}
</script>
<style scoped>
.v-expansion-panel-content__wrap
{
  text-align: left !important;
}
.mdi-menu-down::before {
    content: "\F35D";
    font-size: 25px !important;
}
.theme--light.v-card.v-card--outlined {
    border: 0px solid rgba(0,0,0,.12);
}
.cst{
  
   display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; 
}

.v-expansion-panel--active:not(:first-child) {
    margin-top: 0px !important;
}
.read{
  text-align: right;
  padding-left: 0px;
}
.read1{
  text-align: left;
}
.col-5 {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
    text-align: left;
}
.col-7 {
    text-align: right;
}
.v-expansion-panel-header {
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    font-size: .9375rem;
    line-height: 1;
    min-height: 48px;
    outline: none;
    padding: 3px 24px;
    position: relative;
    transition: min-height .3s cubic-bezier(.25,.8,.5,1);
    width: 100%;
}
</style>